// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_2Nvgq_XuczFKk0FgCt_eJM"};